import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';


@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {


payment:any;


bookingId:any;


constructor(
private route:ActivatedRoute,
private apiService:ApiServiceService
){}



ngOnInit(){
console.log("PAYMENT DETAILS PAGE LOADED");
const token =
localStorage.getItem('sessionToken');

let email:any=null;

if(token){

const payload =
JSON.parse(
atob(token.split('.')[1])
);

email=payload.email;
console.log("TOKEN PAYLOAD:", payload);
console.log("EMAIL FROM TOKEN:", email);

}
console.log("Calling API with email:", email);

this.apiService
.getUserPayments(email)
.subscribe({

next:(res:any)=>{

console.log(res);

this.payment=res.data;

},

error:(err)=>{

console.log(err);

}

});

}
payNow(item:any){

console.log(
"PAY NOW CLICKED",
item
);


// create razorpay order

const orderPayload={

amount:item.remaining_amount || item.total_amount,

currency:"INR",

receipt:"payment_"+Date.now()

};


this.apiService
.createMerchantPaymentOrder(orderPayload)
.subscribe({

next:(res:any)=>{


console.log(
"RAZORPAY ORDER",
res
);


this.openRazorpay(
res.data,
item
);



},

error:(err)=>{

console.log(
"ORDER ERROR",
err
);

}


});


}
openRazorpay(order:any,item:any){


const options:any={


key:order.key,


amount:order.amount,


currency:order.currency,


name:"Weddingly",


description:item.service_name,


order_id:order.orderId,



handler: (response: any) => {

  console.log("PAYMENT SUCCESS", response);

  this.apiService
    .completeAdvancePayment(item.bookingId)
    .subscribe({

      next: (res: any) => {

        console.log("PAYMENT UPDATED", res);

        alert("Remaining payment completed successfully.");

        // Refresh payment list
        this.ngOnInit();

      },

      error: (err) => {

        console.log(err);

        alert("Payment was successful, but updating the payment status failed.");

      }

    });

},


prefill:{


email:item.customer_email


},


theme:{

color:"#800020"

}


};



const razorpay =
new (window as any).Razorpay(options);


razorpay.open();


}


}